/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-23 14:50:07
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 13:58:34
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorTabbar/Item/index.tsx
 */
import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import move from 'array-move';
import { InfoCircleFilled } from '@ant-design/icons';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import { Icon } from '@/src/tools/icon';
import { Collapse, Input, Radio } from '@/src/components/Antd';
import { TabBarItem, TabBarSetting } from '@/src/types/common/SalesChannel';
import {
  ContentCard,
  DragNDropColumns,
  TextAndEditIcon,
} from '@/src/components';
import ColorPickerWidthTitle from '../../Components/ColorPickerWidthTitle';
import Section from '../../../../constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { handleOnFormatCurrentSCTimeAndDate } from '@/src/tools/tools';

import styles from './style.module.less';

type Props = {
  id?: string;
  open: boolean;
  isDefault: boolean;
  onResetDefaultSetting?: () => void;
  onCancelResetDefaultSetting?: () => void;
  onDuplicate?: (id: string) => void;
  onDeleteItem?: (id: string) => void;
  onCancelDeleteItem?: () => void;
  onOpen?: (id: string) => void;
  onSettingTime?: () => void;
  onDataChange: (data: TabBarSetting) => void;
  onAddTab?: () => void;
  onEditTab?: (tab: TabBarItem) => void;
  data: TabBarSetting;
  timeZone: string;
  err?: JSX.Element | string;
  showError?: boolean;
  tabsError: Array<number>;
  isPrimary?: boolean;
};

function Item({
  id,
  open,
  isDefault,
  onOpen,
  onResetDefaultSetting,
  onCancelResetDefaultSetting,
  onDuplicate,
  onDeleteItem,
  onCancelDeleteItem,
  onDataChange,
  onSettingTime,
  onAddTab,
  onEditTab,
  data,
  timeZone,
  err,
  showError,
  tabsError,
  isPrimary,
}: Props) {
  const handleNameChange = (value: string) => {
    onDataChange({ ...data, name: value });
  };

  const handleDisplayChange = (e: any) => {
    const value = e?.target?.value;
    onDataChange({ ...data, display: value });
  };

  const handleBgCChange = (color) => {
    onDataChange({ ...data, backgroundColor: color });
  };

  const handleInaciveCChange = (color) => {
    onDataChange({ ...data, inactiveColor: color });
  };

  const handleActiveCChange = (color) => {
    onDataChange({ ...data, activeColor: color });
  };

  const handleTabDelete = (index: number) => {
    const result = data.tabs.slice();
    let temp = [];
    temp = result.map((v, i) => {
      if (i === index + 1) {
        if (result[index].isHome) {
          return { ...v, isHome: true };
        } else {
          return v;
        }
      }
      return v;
    });
    temp.splice(index, 1);
    onDataChange({ ...data, tabs: temp });
  };

  const handleSortTab = (e) => {
    const { newIndex, oldIndex } = e.data;
    const { tabs } = data;
    onDataChange({ ...data, tabs: move(tabs, oldIndex, newIndex) });
  };

  const handleEditTab = (tab: TabBarItem) => {
    onEditTab(tab);
  };

  const handleChangeHomeTab = (index: number) => {
    const { tabs } = data;
    onDataChange({
      ...data,
      tabs: tabs.map((v, i) => ({ ...v, isHome: i === index })),
    });
  };

  const renderTime = () => {
    if (data.endTime && data.startTime) {
      const start = moment(data.startTime);
      const end = moment(data.endTime);
      return `${handleOnFormatCurrentSCTimeAndDate(
        start,
      )}-${handleOnFormatCurrentSCTimeAndDate(end)}`;
    } else {
      return 'please set start and end time';
    }
  };

  const getMoreOptions = () => {
    if (isDefault) {
      return [
        {
          key: 'default',
          body: 'Restore default setting',
          isDangerous: true,
          displayWarningModal: true,
          modalOnOk: onResetDefaultSetting,
          modalOkText: 'Restore',
          modalOnCancel: onCancelResetDefaultSetting,
          modalTitle: 'Restore default setting',
          modalContent: 'Are you sure to restore default setting ?',
        },
      ];
    } else {
      return [
        {
          key: 'duplicate',
          body: 'Duplicate',
          onClick: onDuplicate.bind(this, id),
        },
        {
          key: 'delete',
          body: 'Delete',
          isDangerous: true,
          displayWarningModal: true,
          modalOnOk: onDeleteItem.bind(this, id),
          modalOnCancel: onCancelDeleteItem,
          modalTitle: 'Delete Tab Bar Setting',
          modalContent: 'Are you sure to delete tab bar setting ?',
        },
      ];
    }
  };

  const renderChildren = (data: TabBarItem, index: number) => {
    const { icon } = data;
    const { url } = icon || {};
    return (
      <TextAndEditIcon
        icon={
          <img src={url} height={48} width={48} style={{ marginRight: 16 }} />
        }
        name={data.title}
        containerClassName={`${
          !isPrimary ? styles.noDelete : styles.container
        }`}
        onClick={handleEditTab.bind(this, data)}
        additional={
          <>
            {showError && tabsError.indexOf(index) !== -1 && (
              <InfoCircleFilled className={styles.iconWarn} />
            )}
            {isPrimary &&
              (data.isHome ? (
                <Icon
                  type={'iconHome1'}
                  className={styles.icon}
                  style={{ color: '#38C568' }}
                />
              ) : (
                <Icon
                  type='iconHomeOutLine1'
                  className={styles.icon}
                  onClick={handleChangeHomeTab.bind(this, index)}
                />
              ))}
          </>
        }
      />
    );
  };

  const renderContent = () => {
    return (
      <div className={styles.content}>
        {isPrimary && (
          <React.Fragment>
            {' '}
            <Section bottomBorder className={styles.section}>
              <div className={styles.title}>
                <span>Name(for internal use)</span>
                <span className={styles.desc}>{`${_.get(
                  data,
                  'name.length',
                  0,
                )}/100`}</span>
              </div>
              <div className={styles.input}>
                <Input
                  value={data.name}
                  onChange={handleNameChange}
                  maxLength={100}
                  size='large'
                />
              </div>
            </Section>
            {!isDefault && (
              <Section bottomBorder className={styles.section}>
                <div className={styles.timeDisplay}>
                  <div
                    className={
                      styles.title
                    }>{`Start Time (UTC ${timeZone})`}</div>
                  <div className={styles.time}>
                    {data.startTime
                      ? handleOnFormatCurrentSCTimeAndDate(data.startTime)
                      : '-'}
                  </div>
                </div>
                <div className={styles.timeDisplay}>
                  <div
                    className={
                      styles.title
                    }>{`End Time (UTC ${timeZone})`}</div>
                  <div className={styles.time}>
                    {data.endTime
                      ? handleOnFormatCurrentSCTimeAndDate(data.endTime)
                      : '-'}
                  </div>
                </div>
                <div className={styles.timeSetting} onClick={onSettingTime}>
                  {'Edit Start and End Time'}
                </div>
              </Section>
            )}
            <Section bottomBorder className={styles.section}>
              <div className={styles.title}>Tab Bar Display Options</div>
              <div className={styles.radio}>
                <Radio
                  value={data.display}
                  onChange={handleDisplayChange}
                  radioList={[
                    {
                      value: 'fixed',
                      disable: false,
                      label: 'Fix at the bottom',
                    },
                    {
                      value: 'scroll',
                      disable: false,
                      label: 'Scroll off and return on reverse-scroll',
                    },
                  ]}
                />
              </div>
            </Section>
            <Section bottomBorder>
              {' '}
              <ItemWrapper>
                <ColorPickerWidthTitle
                  title={`Background Colour`}
                  color={data.backgroundColor}
                  onChange={handleBgCChange}
                  multi
                />
              </ItemWrapper>
              <ItemWrapper>
                {' '}
                <ColorPickerWidthTitle
                  title={`Inactive Tab Icon & Text Colour`}
                  color={data.inactiveColor}
                  onChange={handleInaciveCChange}
                  multi
                />
              </ItemWrapper>{' '}
              <ItemWrapper>
                <ColorPickerWidthTitle
                  title={`Active Tab Icon & Text Colour`}
                  color={data.activeColor}
                  onChange={handleActiveCChange}
                  multi
                />
              </ItemWrapper>
            </Section>
          </React.Fragment>
        )}

        <Section bottomBorder className={styles.tabs}>
          <DragNDropColumns
            title={title()}
            hideTitleRightFunction
            childGenerate={renderChildren}
            droppableId={id}
            disabled={!isPrimary}
            {...(isPrimary
              ? {
                  onDelete: handleTabDelete,
                  addText: '+ Add Tab',
                  onAdd: onAddTab,
                }
              : { hideAdd: true })}
            // onDelete={handleTabDelete}
            // addText={'+ Add Tab'}
            // onAdd={onAddTab}
            onSort={handleSortTab}
            data={data.tabs}
            amountRestriction={[2, 6]}
          />
        </Section>
      </div>
    );
  };

  const title = () => (
    <>
      <div className={styles.title}>Tabs</div>
      <div className={styles.subTitle}>Minimum 2 tabs and maximum 6 tabs</div>
    </>
  );
  return (
    <Collapse
      id={id}
      clickToExpand
      open={open}
      err={err}
      title={
        <ContentCard
          title={isDefault ? 'Default Tab Bar' : renderTime()}
          content={data.name}
          err={showError}
          hideDots={!isPrimary}
          dotsFunctions={getMoreOptions()}
        />
      }
      content={renderContent()}
      expandOffset={12}
      onClickTrigger={onOpen.bind(this, id)}
    />
  );
}

export default Item;
